import axios from './axios'
import Attachment from 'Models/Attachment'
import { map, mapKeys, snakeCase } from 'lodash'

async function getAll (params) {
  params = mapKeys(params, (value, key) => snakeCase(key))
  // console.log('Params', params)

  return axios.get(`/attachments`, { params })
    .then(response => map(response.data, newAttachment))
    .catch(console.error)
}

async function getById ({ id }) {
  return axios.get(`/attachments/${id}`)
    .then(response => newAttachment(response.data))
    .catch(console.error)
}

async function update (attachment) {
  const id = attachment.id
  delete attachment.id
  return axios.put(`/attachments/${id}`, { attachment: { ...attachment } })
    .then(response => newAttachment(response.data))
    .catch(console.error)
}

async function destroy ({ id }) {
  return axios.delete(`/attachments/${id}`)
    .then(response => newAttachment(response.data))
    .catch(console.error)
}

function newAttachment (attachment) {
  return new Attachment(attachment)
}

export default {
  getAll,
  getById,
  update,
  destroy,
}
